import { RefreshCw, Search } from "lucide-react";
import type { PageId } from "../types";

interface TopbarProps {
  page: PageId;
  generatedAt: string | null;
  isRefreshing: boolean;
  onRefresh: () => void;
  searchValue: string;
  onSearchChange: (value: string) => void;
}

const pageTitles: Record<PageId, { eyebrow: string; title: string }> = {
  overview: { eyebrow: "Production Control", title: "批量生产总览" },
  materials: { eyebrow: "Asset Packages", title: "商品素材工作区" },
  reviews: { eyebrow: "Human-in-the-loop", title: "人工审核队列" },
  adapters: { eyebrow: "Integration Layer", title: "服务接入状态" },
};

export function Topbar({
  page,
  generatedAt,
  isRefreshing,
  onRefresh,
  searchValue,
  onSearchChange,
}: TopbarProps) {
  const title = pageTitles[page];
  return (
    <header className="topbar">
      <div className="page-identity">
        <span>{title.eyebrow}</span>
        <h1>{title.title}</h1>
      </div>
      <div className="topbar-actions">
        {(page === "materials" || page === "reviews") && (
          <label className="search-field">
            <Search size={16} aria-hidden="true" />
            <span className="sr-only">搜索</span>
            <input
              value={searchValue}
              onChange={(event) => onSearchChange(event.target.value)}
              placeholder="搜索商品或版本"
            />
          </label>
        )}
        <div className="sync-meta">
          <span>最近生成</span>
          <strong>
            {generatedAt
              ? new Date(generatedAt).toLocaleString("zh-CN", {
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                })
              : "尚未运行"}
          </strong>
        </div>
        <button
          type="button"
          className="icon-button"
          onClick={onRefresh}
          disabled={isRefreshing}
          aria-label="刷新数据"
          title="刷新数据"
        >
          <RefreshCw
            size={18}
            className={isRefreshing ? "is-spinning" : ""}
            aria-hidden="true"
          />
        </button>
      </div>
    </header>
  );
}

